// src/pages/Home/index.jsx
import { useState, useEffect } from 'react';
import { Card, Typography, List, Avatar, Button, Modal, Form, Input, Divider, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { EditOutlined, MailOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const Home = () => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [user, setUser] = useState({ name: '访客' });
  
  // 加载用户数据
  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const myData = [
    { title: '我的文章', count: 5 },
    { title: '我的收藏', count: 12 },
    { title: '我的评论', count: 23 },
  ];

  const showEditModal = () => {
    const currentUser = localStorage.getItem('user');
    if (!currentUser) {
      message.warning('请先登录');
      navigate('/auth');
      return;
    }
    
    form.setFieldsValue(JSON.parse(currentUser));
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleSubmit = (values) => {
    const updatedUser = { ...user, ...values };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
    message.success('个人资料已更新');
    setIsModalVisible(false);
  };

  return (
    <div style={{ padding: 24 }}>
      <Card>
        <Title level={2}>我的主页</Title>
        
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          marginBottom: 24,
          position: 'relative' 
        }}>
          <Avatar size={64} style={{ backgroundColor: '#1890ff', marginRight: 16 }}>
            {user.name.charAt(0)}
          </Avatar>
          <div>
            <Title level={4} style={{ margin: 0 }}>{user.name}</Title>
            <Text type="secondary">欢迎来到个人主页</Text>
          </div>
          
          <div style={{ 
            position: 'absolute', 
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)'
          }}>
            <Button 
              type="primary" 
              icon={<EditOutlined />}
              onClick={showEditModal}
            >
              编辑个人资料
            </Button>
          </div>
        </div>

        {/* 个人信息显示区域 */}
        {(user.email || user.bio) && (
          <div style={{ marginBottom: 24 }}>
            <Divider />
            <Title level={4} style={{ marginBottom: 16 }}>
              <InfoCircleOutlined style={{ marginRight: 8 }} />
              个人信息
            </Title>
            
            {user.email && (
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                <MailOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                <Text strong style={{ marginRight: 8 }}>邮箱:</Text>
                <Text>{user.email}</Text>
              </div>
            )}
            
            {user.bio && (
              <div style={{ marginTop: 12 }}>
                <Text strong style={{ marginRight: 8 }}>个人简介:</Text>
                <Text>{user.bio}</Text>
              </div>
            )}
            <Divider />
          </div>
        )}

        {/* 统计列表 */}
        <List
          dataSource={myData}
          renderItem={item => (
            <List.Item>
              <List.Item.Meta
                title={item.title}
              />
              <Text strong>{item.count}</Text>
            </List.Item>
          )}
        />
      </Card>

      {/* 编辑资料弹窗 */}
      <Modal
        title="编辑个人资料"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="name"
            label="姓名"
            rules={[{ required: true, message: '请输入姓名' }]}
          >
            <Input placeholder="请输入姓名" />
          </Form.Item>

          <Form.Item
            name="email"
            label="邮箱"
            rules={[{ type: 'email', message: '请输入有效的邮箱地址' }]}
          >
            <Input placeholder="请输入邮箱" />
          </Form.Item>

          <Form.Item
            name="bio"
            label="个人简介"
          >
            <Input.TextArea placeholder="请输入个人简介" rows={3} />
          </Form.Item>

          <Form.Item style={{ textAlign: 'right' }}>
            <Button onClick={handleCancel} style={{ marginRight: 8 }}>
              取消
            </Button>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Home;